import { ExploreApiEndpoints } from '@contracts';

export const EXPLORE_ENDPOINTS: ExploreApiEndpoints = {
  getEmsExplore: {
    path: 'get/ems_explore/',
  },
  getExploreByParam:{
    path:'explore_parameter/',
  },
  getExploreByMeter:{
    path:'explore_meter/',
  }
};
